'use client';

import { useSyncExternalStore } from 'react';
import { CONSENT_GRANTED_EVENT, ConsentCategory } from './constants';
import TrackingConsent from './TrackingConsent';
import appendConsentParams from './appendConsentParams';

const subscribe = (onStoreChange: () => void) => {
  window.addEventListener(CONSENT_GRANTED_EVENT, onStoreChange);
  return () => {
    window.removeEventListener(CONSENT_GRANTED_EVENT, onStoreChange);
  };
};

const getSnapshot = (): string => {
  const consent = TrackingConsent.getInstance();
  return `${ consent.hasConsent(ConsentCategory.Functional) }:${ consent.hasConsent(ConsentCategory.Marketing) }`;
};

const getServerSnapshot = (): string => 'false:false';

/**
 * Returns a login URL with consent params appended.
 * Recomputed on every render (so it stays in sync with the caller's current route),
 * and re-renders when consent is granted via the cookie banner.
 */
function useLoginUrlWithConsent(getUrl: (() => string) | string): string {
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const baseUrl = typeof getUrl === 'function' ? getUrl() : getUrl;
  return appendConsentParams(baseUrl);
}

export default useLoginUrlWithConsent;
